var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSdStake = function SvgSdStake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 16.496a.034.034 0 0 0 .017-.03l-.014-4.706 1.373-.721.057 6.235-5.413 3.076-.004-1.51 3.984-2.344Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.36 10.983a.034.034 0 0 0-.018-.03l-4.2-2.222 1.566-.887 3.985 2.496.022 7.535-1.297-.602-.057-6.29ZM6.883 1.684 6.876.058l6.8 3.871.004 1.55-6.797-3.795ZM1.268 4.787a.034.034 0 0 0-.018.03l-.021 6.18-1.171.866-.024-7.856L6.807.06l.006 1.625-5.545 3.103Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.92 20.44 5.466-3.106 1.29.599-6.808 4.026-6.757-3.834 5.39-3.16a.034.034 0 0 0-.001-.06l-1.43-.787-3.983-2.191 1.179-.87 6.833 3.903-4.052 2.286h0l-1.375.765a.034.034 0 0 0 0 .06l4.214 2.37c.01.005.023.005.034 0ZM8.055 8.764l4.198 2.22-1.366.72-5.395-3.046 5.393-3.161a.034.034 0 0 0 0-.06l-1.3-.741-2.715-1.55a.034.034 0 0 0-.034 0l-4.03 2.306-1.444-.637 5.486-3.07 6.796 3.794-3.951 2.237.016.03-.016-.03-1.639.927a.034.034 0 0 0 .001.06Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m6.865 18.842.004 1.51-4.11-2.312 1.306-.726 2.8 1.528ZM4.054 14.187l1.36.748-5.338 3.13-.004-1.626 3.982-2.252ZM9.567 4.765l1.23.703-5.34 3.13.015-1.545 4.095-2.288ZM2.786 10.35c0 .012.007.024.018.03l5.324 2.935.004 1.583-6.836-3.906.021-6.126 1.455.642.014 4.842Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSdStake;